﻿import Vue from "vue";
import Component from "vue-class-component";
import HotEditableFormManager = require("./hotEditable/HotEditableFormManager");
import { IHotEditableFormParentVue } from "../../common";
import common = require("../../common");
import SharedHotEditableParentForm = require("./hotEditable/SharedHotEditableParentForm");
import HotEditableFormLoader = require("./hotEditable/HotEditableFormLoader");
import HotEditableSelectComponent = require("./hotEditable/HotEditableSelectComponent");
import HotEditableHiddenFieldComponent = require("./hotEditable/HotEditableHiddenFieldComponent");
import HotEditableTextboxComponent = require("./hotEditable/HotEditableTextboxComponent");
import HotEditableAddressComponent = require("./hotEditable/HotEditableAddressComponent");
import HotEditableCheckboxComponent = require("./hotEditable/HotEditableCheckboxComponent");
import utilities = require("../utilities");
import context = require("../context");

interface IInitialData {
    formName: string;
    autoSearch?: boolean;
    loadFormModeFromUrl?: boolean;
    embeddedContentModels?: common.IEmbeddedContentModel[];
    bag?: {};
}
@Component
class GestionPersonneFermeVue extends Vue implements IHotEditableFormParentVue {
    shared: SharedHotEditableParentForm;
    formMode = common.HotEditableFormModes.original;
    formManager: HotEditableFormManager;
    culture?: common.Cultures;
    isVisibleToggleButton = false;
    searchPersonneResultsInfoHtml = '';
    forceUpdate = "1";
    initTrigger = '';
    bag = {};
    autoSearch = false;
    _bagTmp: {};
    _lastBagTimemoutId = null as NodeJS.Timeout;
    _initialConcurrencySumCheck: string;
    _manageButtonsOnFormModeChange: boolean;
    // Specific
    isVisiblePrenomField = true;
    isVisibleAdresseCiviqueActions = true;
    _exemptionVoteAndCotiLinked: boolean;

    beforeCreate() {
        const rootId = (this as any).$initialData.vueElId as string;
        const initialConcurrencySumCheck = (this as any).$initialData.concurrencySumCheck as string || null;
        const includesConcurrencySumCheck = (this as any).$initialData.includesConcurrencySumCheck as boolean || !!initialConcurrencySumCheck;
        this._initialConcurrencySumCheck = initialConcurrencySumCheck;

        // Specific
        this._exemptionVoteAndCotiLinked = (this as any).$initialData.exemptionVoteAndCotiLinked === true;

        HotEditableFormLoader.prepareComponentsMarkupFromTarget(true, includesConcurrencySumCheck, rootId).loadComponentsFromParent(this);

        const formName = ((this as any).$initialData as IInitialData).formName;
        this.formManager = new HotEditableFormManager(this, formName, {
            loadFormModeFromUrl: ((this as any).$initialData as IInitialData).loadFormModeFromUrl !== false,
            embeddedContentModels: (((this as any).$initialData as IInitialData).embeddedContentModels || []).sort((a, b) => {
                return a.order - b.order;
            })
        });
        this.shared = new SharedHotEditableParentForm(this.formManager);
        this.culture = context.culture.get();
        this.autoSearch = ((this as any).$initialData as IInitialData).autoSearch === true;
        this._bagTmp = ((this as any).$initialData as IInitialData).bag || {};

        this.$options.el = '#' + rootId;
    }

    destroyComponents() {
        this.formManager.destroyComponents();
        this.formManager = null;
        return this;
    }

    created() { }
    beforeMount() {
        this.initTrigger = "1";
    }
    mounted() {
        this.bag = this._bagTmp;

        if (!!this._initialConcurrencySumCheck)
            this.initConcurrencySumCheck(this._initialConcurrencySumCheck);

        this.initTrigger = "1";

        // Specific
        this.$nextTick(() => {
            this.updateFieldsFromPersonneLiee();
            if (this.autoSearch)
                this.autoSearchOnInit();
        });
    }
    private onInit(initTrigger: string, action: () => void | string) {
        if (!initTrigger)
            return '';
        this.initTrigger = '';
        if (action)
            action();
        return action ? action() || '' : '';
    }
    updateBagOnInit(initTrigger: string, key: string, value?: any) {
        return this.onInit(initTrigger, () => {
            this.setToBag(key, value);
            return value;
        });
    }
    /** Uniquement pour les v-on:click|etc. Sinon utiliser directement : utilities.copyToClipboard(text) */
    copyToClipboard(text: string) {
        utilities.copyToClipboard(text);
        return this;
    }
    applyUpdate(actionValue?: string, actionType?: common.HotEditableActionTypes) {
        this.formManager.applyUpdate(actionValue, actionType);
        return this;
    }
    getBagRaw() {
        const r = utilities.serializeBag(this.bag || {});
        return r;
    }
    getFromBag(key: string) {
        const r = this.bag[key];
        return r || r === false || r === 0 || r === '' ? r : null;
    }

    setToBag(key: string, value?: any, delayMs?: number, forceDelayedSetToBeExecuted?: boolean) {
        delayMs = delayMs || 0;
        forceDelayedSetToBeExecuted = forceDelayedSetToBeExecuted === true;
        const f = () => { this.$set(this.bag, key, value || value === false || value === 0 || value === '' ? value : ''); }
        if (!forceDelayedSetToBeExecuted && this._lastBagTimemoutId) {
            clearTimeout(this._lastBagTimemoutId);
            this._lastBagTimemoutId = null;
        }
        if (delayMs)
            this._lastBagTimemoutId = setTimeout(f, Math.max(0, Math.min(15000, delayMs)));
        else
            f();
        return this;
    }
    getBooleanFromBag(key: string, defaultValue?: boolean) {
        const val = this.getFromBag(key);
        if (val === true || val === false)
            return val;
        return defaultValue ?? false;
    }
    setBooleanToBag(key: string, value: boolean, delayMs?: number, forceDelayedSetToBeExecuted?: boolean) {
        this.setToBag(key, value === true, delayMs, forceDelayedSetToBeExecuted);
        return this;
    }
    // setToBag(key: string, value: any) {
    //     this.$set(this.bag, key, value);
    //     return this;
    // }
    toggleBagBoolean(key: string, delayMs?: number, forceDelayedSetToBeExecuted?: boolean) {
        this.setToBag(key, !this.getBooleanFromBag(key), delayMs, forceDelayedSetToBeExecuted);
        return this;
    }
    updateBagWhere(whereClause: (key: string, val?: any) => boolean, value?: any) {
        if (whereClause)
            for (let k in this.bag)
                if (whereClause(k, this.bag[k]))
                    this.bag[k] = value;
    }
    updateBagWhereKeyStartWith(startWith: string, value?: any, excludedKeys?: string | string[]) {
        if (!startWith) return;
        excludedKeys = excludedKeys || [];
        if (!Array.isArray(excludedKeys))
            excludedKeys = [excludedKeys];
        const isExcluded = (x: string) => {
            if (x)
                for (let i = 0; i < excludedKeys.length; i++)
                    if (excludedKeys[i] === x)
                        return true;
            return false;
        };
        this.updateBagWhere(k => !isExcluded(k) && k.startsWith(startWith), value);
    }

    updateBag(updated: common.IBag) {
        if (!updated)
            return this;
        var isUpdated = false;
        if (updated && updated.raw)
            for (let k in updated.raw) {
                this.bag[k] = updated.raw[k];
                if (!isUpdated)
                    isUpdated = true;
            }
        if (isUpdated)
            this.$forceUpdate();
        return this;
    }
    setManageButtonsOnFormModeChange(value: boolean) {
        this._manageButtonsOnFormModeChange = value !== false;
        return this;
    }

    manageButtonsOnFormModeChange() {
        return this._manageButtonsOnFormModeChange !== false;
    }
    private initConcurrencySumCheck(sumCheck?: string) {
        const f = this.formManager.getFieldByName("ConcurrencySumCheck");
        if (f)
            f.setFromTextualValue(sumCheck || '');
        return this;
    }
    // setActionConfirmation(key: string, action?: () => void) {
    //     if (!key)
    //         throw "L'argument 'key' est NULL.";

    //     const f = this.formManager.getFieldByName(key);

    //     if (!f)
    //         throw "Le champ correspondant au nom '" + key + "' n'existe pas.";

    //     f.setFromTextualValue("true");

    //     if (action)
    //         this.$nextTick(action);

    //     return this;
    // }
    refreshEmbeddedComponents(urlParameters?: {}) {
        this.formManager.refreshEmbeddedComponents(urlParameters);
    }
    refreshBrotherEmbeddedComponents() {
        if (!this.shared.isHotEmbeddedComponent()) throw "[EmbeddedComponent] Le formulaire actuel n'est pas un widget.";
        const name = this.shared.getCurrentEmbeddedComponentName();
        this.formManager.refreshBrotherEmbeddedComponents(name);
        return this;
    }
    restoreBrotherEmbeddedComponents() {
        if (!this.shared.isHotEmbeddedComponent()) throw "[EmbeddedComponent] Le formulaire actuel n'est pas un widget.";
        const name = this.shared.getCurrentEmbeddedComponentName();
        this.formManager.restoreBrotherEmbeddedComponents(name);
        return this;
    }
    ensureBrotherEmbeddedComponentsIsDefaultUrl() {
        if (!this.shared.isHotEmbeddedComponent()) throw "[EmbeddedComponent] Le formulaire actuel n'est pas un widget.";
        const name = this.shared.getCurrentEmbeddedComponentName();
        this.formManager.ensureBrotherEmbeddedComponentsIsDefaultUrl(name);
        return this;
    }
    refreshForceUpdate() {
        this.forceUpdate = utilities.createGuid("N");
    }

    // Specific 
    autoSearchOnInit() {
        const nomField = this.formManager.getFieldByName("Nom") as HotEditableTextboxComponent;
        if (nomField.elementValue)
            this.formManager.applyUpdate("search", common.HotEditableActionTypes.apply);
        return this;
    }
    hasPersonneLiee() {
        const x = this.getIdPersonneLiee();
        return !!x;
    }
    hasSelectedPersonneResult() {
        const x = this.getSelectedSearchPersonne();
        return x ? x.code || null : null;
    }
    onEstPersonneMoralUpdate() {
        const checkbox = this.formManager.getFieldByName("EstPersonneMorale") as HotEditableCheckboxComponent;
        const prenom = this.formManager.getFieldByName("Prenom");
        const isPersonneMorale = checkbox.elementValue;
        const correspondant = this.formManager.getFieldByName("EstCorrespondant") as HotEditableCheckboxComponent;
        const exploitant = this.formManager.getFieldByName("EstExploitant") as HotEditableCheckboxComponent;
        const autorise = this.formManager.getFieldByName("EstAutorise") as HotEditableCheckboxComponent;
        const mandataire = this.formManager.getFieldByName("EstMandataire") as HotEditableCheckboxComponent;        
        if (isPersonneMorale) {
            const nom = this.formManager.getFieldByName("Nom");
            const updatedValue = (nom.getTextualValue() + " " + prenom.getTextualValue()).trim();
            nom.setFromTextualValue(updatedValue);
            prenom.setFromTextualValue();
            correspondant.check(false);
            autorise.check(false);
            exploitant.check(true);

            if (mandataire)
                mandataire.check(false);
        }
        else {
            exploitant.check(false);
        }
        this.isVisiblePrenomField = !checkbox.elementValue;
        return isPersonneMorale;
    }
    onExemptionCotiUpdate() {
        if (this._exemptionVoteAndCotiLinked) {
            const source = this.formManager.getFieldByName("ExemptionCoti");
            const destination = this.formManager.getFieldByName("ExemptionVote");
            destination.setFromTextualValue(source.getTextualValue());
        }
        return this;
    }
    onExemptionVoteUpdate() {
        if (this._exemptionVoteAndCotiLinked) {
            const source = this.formManager.getFieldByName("ExemptionVote");
            const destination = this.formManager.getFieldByName("ExemptionCoti");
            destination.setFromTextualValue(source.getTextualValue());
        }
        return this;
    }
    updateFieldsFromPersonneLiee() {
        const fieldNamesToDisabled = [
            "SearchPersonneResults",
            "Nom",
            "Prenom",
            "EstPersonneMorale",
            "CodeLangueCommunication",
            "IdSexe",
            "AdresseCivique"
        ];
        const fieldsToDisabled = this.formManager.getFieldsByNames(fieldNamesToDisabled);
        const isDisabled = this.hasPersonneLiee();
        for (let i = 0; i < fieldsToDisabled.length; i++) {
            const f = fieldsToDisabled[i];
            if (f.fieldType === common.HotEditableFieldTypes.address) {
                if (isDisabled)
                    (f as HotEditableAddressComponent).updateAllDisabled(isDisabled);
                else
                    (f as HotEditableAddressComponent).restoreAllOriginalDisabledValues();
                continue;
            }
            f.disabled = isDisabled;
        }

        this.isVisibleAdresseCiviqueActions = !isDisabled;

        return this;
    }
    private getSelectedSearchPersonne() {
        if (!this.formManager)
            // Initialement le formManager est NULL.
            return null;
        const f = this.formManager.getFieldByName("SearchPersonneResults") as HotEditableSelectComponent;
        return f ? f.elementValue || null : null;
    }
    private getIdPersonneLiee() {
        if (!this.formManager)
            // Initialement le formManager est NULL.
            return null;
        const f = this.formManager.getFieldByName("IdPersonne") as HotEditableHiddenFieldComponent;
        return f ? f.elementValue || null : null;
    }
    setSearchPersonneResultOptions(options?: common.IHotEditableSelectOption[], selectedOption?: common.IHotEditableSelectOption) {
        const f = this.formManager.getFieldByName("SearchPersonneResults") as HotEditableSelectComponent;

        f.options = options || [];

        f.setFromTextualValue(selectedOption ? selectedOption.code : null);

        this.searchPersonneResultsInfoHtml = this.getSearchPersonneResultsInfo(f.options.length);

        return this;
    }
    getSearchPersonneResultsInfo(resultsCount?: number) {

        if (!resultsCount)
            return "Aucun résultat";

        return resultsCount === 1
            ? "1 résultat trouvé"
            : resultsCount + " résultats trouvés";
    }
    setSearchPersonneResultsIsRunning() {
        this.searchPersonneResultsInfoHtml = "Recherche en cours...";
    }
}

export = GestionPersonneFermeVue;
